var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fade-transition',{attrs:{"origin":"center","mode":"out-in","duration":250}},[_c('div',{staticClass:"layout-child-page"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }